const POLLING_INTERVAL = 15000;
export default POLLING_INTERVAL;